import { getApiBaseUrl } from '../config/api';

export interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
  order_index: number;
  company_id: number;
  created_by_id: number | null;
  created_at: string | null;
  updated_at: string | null;
}

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listFAQs = async (): Promise<FAQItem[]> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/list`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('載入失敗');
  return res.json();
};

export const createFAQ = async (
  question: string,
  answer: string,
  category = ''
): Promise<FAQItem> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ question, answer, category }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || '新增失敗');
  }
  return res.json();
};

export const updateFAQ = async (
  id: number,
  question: string,
  answer: string,
  category = ''
): Promise<FAQItem> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ question, answer, category }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || '更新失敗');
  }
  return res.json();
};

export const deleteFAQ = async (id: number): Promise<void> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || '刪除失敗');
  }
};

export const uploadFAQDocx = async (file: File): Promise<FAQItem[]> => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/upload-docx`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || '上傳失敗');
  }
  const data = await res.json();
  return data.imported as FAQItem[];
};

export const reorderFAQs = async (orderedIds: number[]): Promise<void> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/reorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ ordered_ids: orderedIds }),
  });
  if (!res.ok) throw new Error('排序更新失敗');
};

export const downloadFAQTemplate = async (): Promise<void> => {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/faq/template`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('下載範本失敗');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'faq_template.docx';
  a.click();
  URL.revokeObjectURL(url);
};
